<template>
  <div id="home">
      <div class="container">
        
      <textCode text="h1" />
      <textHeader text="Hi," home="true" />
      <div class="username">
        <textHeader text="I'm " home="true" />
        <span class="initial-name">B</span><span class="initial-name2">B</span
          ><textHeader text="intang," home="true" />
        </div>
        <textHeader text="Web Developer" close="true" home="true" />
        <textCode text="p" />
        <p class="desc">Fullstack & AI Developer 🤖</p>
        <textCode text="p" isClose />
        <br />
        <buttonPrimary text="Download CV" />
      </div>
      <vue-particles
        color="#fd475a"
        :particleOpacity="0.7"
        :particlesNumber="200"
        shapeType="circle"
        :particleSize="4"
        linesColor="#00f2ea"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
       style="position: fixed; top: 0; left: 0; right: 0; bottom: 0;"
      >
    </vue-particles>
    <mediaSosial/>
  </div>
</template>

<script>
import Vue from 'vue'
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
import TransitionMixin from "@/mixins/transition";
import mediaSosial from "../components/atoms/media-sosial.vue";
export default {
  name: "Home",
  mixins: [TransitionMixin],
  components: {
    textHeader: () => import("@/components/atoms/text-header.vue"),
    textCode: () => import("@/components/atoms/text-code.vue"),
    buttonPrimary: () => import("@/components/atoms/button-primary.vue"),
    mediaSosial
  },
  methods: {
    handleAbout() {
      this.$router.push("/about");

      this.navTransition(1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/home.scss";
</style>
